import React from 'react';
import HealthCareRegulationCaseTypeSelect from './HealthCareRegulationCaseTypeSelect';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';

const HealthCareRegulationCaseTypeSelectField: React.FC<
	BaseFieldProps
> = props => (
	<BaseField {...props}>
		<HealthCareRegulationCaseTypeSelect />
	</BaseField>
);

export default HealthCareRegulationCaseTypeSelectField;
